module.exports = __webpack_public_path__ + "static/media/bgHomePaqCompletoPC.7081da35.jpg";